export const appendSvgHeightWidth = (svgElement) => {
  svgElement.setAttribute("height", "100%");
  svgElement.setAttribute("width", "100%");
};

export const appendSvgStyle = (svgElement, styleString) => {
  const svgNS = "http://www.w3.org/2000/svg";
  const styleElement = svgElement.querySelector("style");

  if (!styleString || styleString.length === 0) {
    styleElement.innerHTML = "";
    return;
  }

  if (styleElement) {
    styleElement.innerHTML = "";
    styleElement.innerHTML = styleString;
  } else {
    const newStyleElement = document.createElementNS(svgNS, "style");
    newStyleElement.innerHTML = styleString;
    svgElement.appendChild(newStyleElement);
  }
};

export const addPatternsDefs = (
  svgElement,
  basePath,
  apartmentPath,
  patternDefsIds
) => {
  const svgNS = "http://www.w3.org/2000/svg";
  let defs =
    svgElement.querySelector("defs") || document.createElementNS(svgNS, "defs");
  const svgViewBox = svgElement.getAttribute("viewBox").split(" ");

  const apartmentURL = `${basePath}/${apartmentPath}`;

  if (defs) {
    const patternElement = document.createElementNS(svgNS, "pattern");
    patternElement.setAttribute("id", patternDefsIds[0]); //TODO: refactor to use different patterns if more 3d styles are added
    patternElement.setAttribute("patternUnits", "userSpaceOnUse");
    patternElement.setAttribute("width", svgViewBox[2]);
    patternElement.setAttribute("height", svgViewBox[3]);
    const imageElement = document.createElementNS(svgNS, "image");
    imageElement.setAttribute("href", `${apartmentURL}.png`);
    imageElement.setAttribute("x", "0");
    imageElement.setAttribute("y", `-${svgViewBox[3]}`); //TODO: important!! test images if they are flipped vertically, if so move the image up by its height
    imageElement.setAttribute("width", svgViewBox[2]);
    imageElement.setAttribute("height", svgViewBox[3]);
    imageElement.setAttribute("transform", "scale(1, -1)"); //TODO: important!! test images if they are flipped vertically
    patternElement.appendChild(imageElement);
    defs.appendChild(patternElement);
    svgElement.appendChild(defs);
  }
};

export const reorderSvgCompartmentsGroup = (svgElement) => {
  const compartmentsGroup = svgElement.querySelector(".compartments");
  const compartments = Array.from(compartmentsGroup.querySelectorAll("g[number]"));

  compartments.sort((a, b) => {
    return parseInt(b.getAttribute("number")) - parseInt(a.getAttribute("number"));
  });

  compartments.forEach(compartment => {
    compartmentsGroup.appendChild(compartment);
  });
};

export const changeBasicColorFills = (svgElement, projectStyle, isFloorPlanMonochromatic) => {
    const compartmentPaths = svgElement.querySelectorAll("path.compartment");

    for (const path of compartmentPaths) {
      const classList = path.getAttribute("class").split(" ");
      const compartmentName = classList.find((cls) => cls.startsWith("id"));
      const fill = projectStyle[`${compartmentName}_color`];

      if (!fill || fill === "" || isFloorPlanMonochromatic) {
        const monoFill = compartmentName === "idTerrace" 
          ? "#ffffff"
          : compartmentName === "idGarden"
            ? "#f0f0f0"
            : "#fafafa";
        path.setAttribute("style", `fill:${monoFill}`);
      } else {
        const fillWithHash = fill.startsWith("#") ? fill : `#${fill}`;
        path.setAttribute("style", `fill:${fillWithHash}`);
      }
    }
  };

export const changeElementsUseHref = (svgElement, basePath) => {
  const uses = svgElement.querySelectorAll("use");
  for (const use of uses) {
    const originalHref = use.getAttribute("href");
    const id = originalHref.split("#")[1];
    const defsHref = `${basePath}/defs.svg#${id}`;
    use.setAttribute("href", defsHref);
  }
};

export const changeElementsMarkersHref = (svgElement, basePath) => {
  const stairwaysGroup = svgElement.querySelector(".stairways");
  if (!stairwaysGroup) return;
  const stairwayGroups = stairwaysGroup.querySelectorAll(".stairway");
  if (!stairwayGroups) return;

  for (const stairway of stairwayGroups) {
    const pathsWithMarkers = stairway.querySelectorAll("path[marker-end], path[marker-start]");
    for (const path of pathsWithMarkers) {
      const markerEnd = path.getAttribute("marker-end");
      const markerStart = path.getAttribute("marker-start");
      if (markerEnd) {
        const originalEndHref = markerEnd.split("url(")[1].split(")")[0];
        const endId = originalEndHref.split("#")[1];
        const defsEndHref = `${basePath}/defs.svg#${endId}`;
        path.setAttribute("marker-end", `url(${defsEndHref})`);
      }
      if (markerStart) {
        const originalStartHref = markerStart.split("url(")[1].split(")")[0];
        const startId = originalStartHref.split("#")[1];
        const defsStartHref = `${basePath}/defs.svg#${startId}`;
        path.setAttribute("marker-start", `url(${defsStartHref})`);
      }
    }
  }
};
